import { Suspense } from 'react';

import type { Classnames, LoaderImageType } from '@snowit/icetypes';

import Typo from '../../Typography/Typo';
import { loaderComponents } from '../Images/lazy';

import cx from 'classnames';
import s from './LoaderImage.module.scss';

export interface ILoaderImage {
  img?: LoaderImageType;
  title?: string;
  text?: string;
  id?: string;
  classNames?: Classnames<'wrapper' | 'img' | 'title' | 'text'>;
}

const LoaderImage = (props: ILoaderImage) => {
  const { img = 'cabins', title, text, id, classNames } = props;

  const getImg = (label?: string) => {
    // il fallback copre anche img fuori dal set, come faceva il default: dello switch
    const Loader = loaderComponents[img] ?? loaderComponents.cabins;
    return (
      // il placeholder tiene lo stesso viewBox dei loader (160x160), cosi' se il
      // chunk non e' ancora pronto non c'e' salto di layout
      <Suspense fallback={<svg viewBox={'0 0 160 160'} aria-hidden={true} />}>
        <Loader a11y={{ label }} />
      </Suspense>
    );
  };

  const renderImg = () => {
    return <div className={cx(s.img, classNames?.img)}>{getImg(title || text)}</div>;
  };

  const renderTitle = () => {
    if (!title) return null;
    return (
      <Typo
        className={cx(s.title, classNames?.title)}
        text={title}
        tag={'h2'}
        size={'xxl'}
        weight={'medium'}
        color={'text'}
      />
    );
  };

  const renderText = () => {
    if (!text) return null;
    return (
      <Typo
        className={cx(s.text, classNames?.text)}
        text={text}
        tag={'p'}
        size={'df'}
        lineHeight={'paragraph'}
        color={'text-l'}
      />
    );
  };

  return (
    <div className={cx(s.wrapper, classNames?.wrapper)} id={id}>
      {renderImg()}
      {renderTitle()}
      {renderText()}
    </div>
  );
};

export default LoaderImage;
